import { useEffect } from "react";
export function useLazyFetch(useLazyQuery, arg, enabled = true) {
    const [trigger, result] = useLazyQuery();

    useEffect(() => {
        if (enabled) trigger(arg, true);
    }, [arg, enabled, trigger]);

    if (result.isError) console.error("useLazyFetch error:", arg, result.error);

    return {
        data: result.data,
        isLoading: enabled && (result.isUninitialized || result.isLoading),
    };
}